import React from "react";

const TermsOfServiceView: React.FC = () => {
    return (
        <div className="overflow-y-auto bg-gray-50 min-h-screen">
            <div className="max-w-4xl mx-auto px-6 py-10 bg-white shadow-lg rounded-lg">
                <h1 className="text-4xl font-extrabold text-gray-800 mb-10 text-center">사이트버니 서비스 이용약관</h1>
                <div className="space-y-10">
                    <p className="text-lg leading-relaxed text-gray-700">
                        사이트버니 서비스를 이용하는 가입자 또는 사용자(이하 “회원” 이라 합니다)는 주식회사 포티투마루 (이하 “회사” 라 합니다)와 아래와 같이 합의 합니다.
                    </p>
                    {/* 목차 */}
                    <ol className="list-decimal list-inside space-y-4 bg-gray-100 p-4 rounded-lg">
                        <li className="text-gray-800 font-medium">제1장 총칙</li>
                        <li className="text-gray-800 font-medium">제2장 계약의 내용</li>
                        <li className="text-gray-800 font-medium">제3장 계약의 존속</li>
                        <li className="text-gray-800 font-medium">제4장 해지 및 손해배상</li>
                        <li className="text-gray-800 font-medium">제5장 기타</li>
                        <li className="text-gray-800 font-medium">부칙</li>
                    </ol>

                    {/* 제1장 총칙 */}
                    <section className="space-y-6">
                        <h2 className="flex text-2xl font-bold text-gray-800 justify-center">제1장 총칙</h2>

                        <article className="space-y-4">
                            <h3 className="text-xl font-semibold text-gray-700">제1조 목적</h3>
                            <p className="text-gray-600">
                                본 약관은 “회사"가 제공하는 사이트버니 서비스 (이하 “서비스”라 함)의 이용과 관련하여, 회사와 회원 상호 간의 권리 및 의무, 서비스 이용 조건 및 절차
                                등 기본적인 사항을 정하는 것을 목적으로 하고 있습니다.
                            </p>
                        </article>

                        <article className="space-y-4">
                            <h3 className="text-xl font-semibold text-gray-700">제2조 용어 정의</h3>
                            <p className="text-gray-600">
                                본 약관에서 사용하는 용어의 정의는 다음 각 호와 같습니다. 각 호에 정의된 용어 이외의, 약관 내 용어의 정의에 대해서는 관계 법령 및 서비스 안내에서
                                정하는 바에 따릅니다.
                            </p>
                            <ol className="list-decimal list-inside space-y-2 pl-6 text-gray-700">
                                <li>
                                    <strong>“회사”</strong>라 함은 ‘컴퓨터 소프트웨어’ 산업과 관련된 경제 활동을 영위하는 자로서 컴퓨터 소프트웨어 서비스(웹, 모바일 웹
                                    서비스 등을 포함합니다) 및 제반 서비스를 제공하는 자로서 본 약관에서는 주식회사 포티투마루를 말합니다.
                                </li>
                                <li>
                                    <strong>“회원”</strong>이라 함은 회사의 서비스 페이지를 통해 가입을 하고, 본 약관에 따라 회사와 이용계약을 체결하여 서비스를 사용하는
                                    고객을 말합니다.
                                </li>
                                <li>
                                    <strong>“서비스”</strong>라 함은 회원이 지정한 웹사이트 및 등록한 데이터를 수집, 학습 후 회원의 웹사이트(또는 연동채널) 방문자에게
                                    질의에 대한 답변 기능을 생성형 AI를 통해 제공하는 업무를 말합니다.
                                </li>
                                <li>
                                    <strong>“업그레이드”</strong>라 함은 서비스의 성능, 기능 등을 개선하여 새로운 버전으로 변경시키는 것을 말합니다.
                                </li>
                                <li>
                                    <strong>“이용료”</strong>라 함은 회원이 가입한 ‘유료 서비스’를 사용하는 이용료를 말합니다.
                                </li>
                                <li>
                                    <strong>“결제”</strong>라 함은 "회사"가 제공하는 ‘유료 서비스’를 이용하기 위하여 회사가 제시한 유료 사용금액을 "회사" 또는
                                    "회사"가 정한 제3자에 지불하는 것을 의미합니다.
                                </li>
                            </ol>
                        </article>

                        <article className="space-y-4">
                            <h3 className="text-xl font-semibold text-gray-700">제3조 약관의 해석</h3>
                            <p className="text-gray-600">
                                본 약관에서 정하지 아니한 사항과 이 약관의 해석에 관하여는 「전자상거래 등에서의 소비자보호에 관한 법률」, 「표시·광고 등의 공정화에 관한 법률」, 「약관의
                                규제에 관한 법률」, 「정보통신망 이용촉진 및 정보보호 등에 관한 법률」, 「저작권법」, 「개인정보 보호법」, 「청소년 보호법」, 「콘텐츠산업 진흥법」,
                                문화체육관광부장관이 정하는 「콘텐츠 이용자보호지침」, 기타 관계법령 또는 상관례에 따릅니다.
                            </p>
                        </article>

                        <article className="space-y-4">
                            <h3 className="text-xl font-semibold text-gray-700">제4조 약관의 효력 및 변경</h3>
                            <ol className="list-decimal list-inside space-y-2 pl-6 text-gray-700">
                                <li>
                                    “회사”는 본 약관의 내용을 "회원"이 쉽게 알 수 있도록 서비스 페이지에 게시합니다.
                                </li>
                                <li>
                                    "회사"는 본 약관의 내용, 상호, 대표자 성명, 영업소 소재지 주소, 전화번호, 이메일주소, 사업자등록번호 등을 "회원"이 쉽게 알 수 있도록 서비스
                                    화면에 게시합니다.
                                </li>
                                <li>
                                    “회사”가 약관을 개정할 경우에는 적용일자 및 개정사유를 명시하여 현행 약관과 함께 제1항의 방식에 따라 그 개정약관의 적용일자 14일 이전부터 적용일
                                    이후 상당한 기간 동안 공지하며, 개정된 약관은 그 적용 일에 효력이 발생합니다. 단, 개정 내용이 "회원"에게 불리한 경우에는 그 시행일 30일
                                    전부터 시행일 이후 상당한 기간 동안 본 서비스 페이지에 게시하고 이메일 또는 휴대전화를 통해 제공하는 등 "회원"이 인지할 수 있는 합리적으로 가능한
                                    방법으로 공지합니다.
                                </li>
                                <li>
                                    "회사"가 전항에 따라 "회원"에게 ‘공지일로부터 개정약관 시행일까지 거부의사를 표시하지 아니하면 승인한 것으로 본다’는 뜻을 명확하게 공지 또는
                                    고지하였음에도 불구하고 "회원"의 거부의 의사표시가 없는 경우에는 변경된 약관에 동의한 것으로 봅니다.
                                </li>
                                <li>
                                    "회원"이 개정약관에 동의하지 않을 경우 "회원"은 본 이용약관 규정에 따라 이용계약을 해지할 수 있습니다.
                                </li>
                                <li>
                                    이 약관은 "회원"이 이 약관에 동의한 날로부터 회원 탈퇴 시까지 적용하는 것을 원칙으로 합니다. 단, 이 약관의 일부 조항은 회원이 탈퇴 후에도
                                    유효하게 적용될 수 있습니다.
                                </li>
                            </ol>
                        </article>
                    </section>

                    {/* 제2장 계약의 내용 */}
                    <section className="space-y-6">
                        <h2 className="flex text-2xl font-bold text-gray-800 justify-center">제2장 계약의 내용</h2>

                        <article className="space-y-4">
                            <h3 className="text-xl font-semibold text-gray-700">제5조 이용계약의 체결</h3>
                            <ol className="list-decimal list-inside space-y-2 pl-6 text-gray-700">
                                <li>
                                    “회사”는 "회사"의 서비스를 이용하고자 하는 자가 본 약관과 개인정보취급방침을 읽고 이에 대하여 "동의" 또는 "확인" 버튼을 누르는 경우 이를
                                    서비스 이용에 대한 신청으로 간주합니다.
                                </li>
                                <li>
                                    "회사"는 "회원"의 유형에 따라 전문기관을 통한 실명확인 및 본인인증을 요청할 수 있습니다. "가입자"는 본인인증에 필요한 이름, 생년월일, 연락처
                                    등을 제공해야 합니다.
                                </li>
                                <li>
                                    "회원"의 유료 서비스 이용 신청 후에 "회사"가 웹상의 안내 및 전자메일로 "회원"에게 통지함으로써 유료 서비스를 개시하며 이 시점에 계약이 성립 된
                                    것으로 간주 합니다.
                                </li>
                                <li>
                                    “회사”는 회원 가입 신청을 완료하였을 때 신청 내용을 확인한 후 지체 없이 이를 승낙하여야 합니다. 단, "회사"는 아래 각 호에 해당하는 경우에는
                                    승낙을 유보하거나 거절할 수 있으며, 사후에 이용계약을 해지할 수 있습니다.
                                    <ol className="list-disc list-inside space-y-2 pl-6 text-gray-700">
                                        <li>본 약관에 의하여 이전에 가입자 자격을 상실한 적이 있는 경우</li>
                                        <li>타인의 명의를 이용한 경우</li>
                                        <li>만 14세 미만의 회원이 법정 대리인 동의 등 필요한 절차를 완료하지 않거나 허위로 한 경우</li>
                                        <li>허위의 정보를 기재하거나, 회사가 제시하는 내용을 기재하지 않은 경우</li>
                                        <li>"회원"의 귀책사유로 인하여 승인이 불가능한 경우</li>
                                        <li>관계 법령, 기타 규정한 제반 사항을 위반하여 신청하는 경우</li>
                                        <li>기술 및 설비의 미 보유로 인하여 서비스 제공이 가능하지 않은 경우</li>
                                    </ol>
                                </li>
                                <li>
                                    "회원"은 개인정보관리 화면을 통하여 언제든지 본인의 개인정보를 열람하고 수정할 수 있습니다.
                                </li>
                            </ol>
                        </article>

                        <article className="space-y-4">
                            <h3 className="text-xl font-semibold text-gray-700">제6조 회원의 의무</h3>
                            <ol className="list-decimal list-inside space-y-2 pl-6 text-gray-700">
                                <li>
                                    “회원”은 정보가 변경되었을 경우 정보변경 메뉴를 통하여 수정해야 합니다. 변경하지 않아 발생되는 손해는 "회원" 본인에게 있습니다
                                </li>
                                <li>
                                    “회원” 은 관계법령, 이 약관의 규정, 이용지침, 서비스 이용안내 및 서비스와 관련하여 공지한 주의사항, "회사"가 통지하는 사항 등을 준수하여야
                                    하며, 기타 "회사"의 업무에 방해되는 행위 및 다음 각호에 해당하는 행위를 해서는 안됩니다.
                                    <ol className="list-disc list-inside space-y-2 pl-6 text-gray-700">
                                        <li>
                                            로그인에 필요한 정보는 "회원" 본인만 사용이 가능하며 타인에게 공유하지 않습니다. 제3자가 "회원"의 정보를 사용하고 있음을 인지한
                                            경우 바로 "회사"에 통보하고 "회사"의 안내를 따라야 합니다.
                                        </li>
                                        <li>
                                            저작권에 위반되는 데이터를 업로드 하여 사용하는 행위
                                        </li>
                                        <li>
                                            타인의 정보를 수집, 도용하여 부정하게 사용하는 행위
                                        </li>
                                        <li>
                                            "회사"와 기타 제3자의 저작권, 영업비밀, 특허권 등 지적재산권을 침해하는 행위
                                        </li>
                                        <li>
                                            외설, 폭력적인 메시지, 기타 공서양속에 반하는 정보를 사용하는 행위
                                        </li>
                                    </ol>
                                </li>
                                <li>
                                    "회사"는 "회원"이 전항에서 금지한 행위를 하는 경우, 위반 행위의 경중에 따라 서비스의 이용정지/계약의 해지 등 서비스 이용 제한, 수사 기관에의
                                    고발 조치 등 합당한 조치를 취할 수 있습니다.
                                </li>
                            </ol>
                        </article>

                        <article className="space-y-4">
                            <h3 className="text-xl font-semibold text-gray-700">제7조 회원 탈퇴 및 자격정지</h3>
                            <ol className="list-decimal list-inside space-y-2 pl-6 text-gray-700">
                                <li>
                                    "회원"은 "회사"에 언제든지 회원탈퇴를 요청할 수 있으며, "회사"는 회원가입 계약해지 요청을 즉시 처리합니다.
                                </li>
                                <li>
                                    "회원"은 회원탈퇴 시 서비스 이용을 위해 기존에 등록한 데이터, 설정한 구성 등의 이용이 불가합니다. 이에 대하여 "회사"가 보존 방법 및 삭제를
                                    안내하였음에도 불구하고 보존 등 조치를 취하지 아니한 경우 "회사"에서 책임을 지지 않습니다.
                                </li>
                                <li>
                                    "회사"는 "회원"이 다음 각 호의 사유에 해당하는 경우, 회원탈퇴 또는 회원자격을 정지시킬 수 있습니다.
                                    <ol className="list-disc list-inside space-y-2 pl-6 text-gray-700">
                                        <li>가입 신청 또는 변경 시 허위 내용을 등록한 경우</li>
                                        <li>"회사" 또는 제3자의 저작권 등 지식 재산권을 침해하는 경우</li>
                                        <li>"회사" 또는 제3자의 명예를 손상시키거나 업무를 방해하는 경우</li>
                                        <li>"회사"의 서비스를 이용하는 과정에서 법령 또는 이 약관이 금지하거나 공서양속에 반하는 행위를 하는 경우</li>
                                        <li>"회사"의 기술적 보호조치를 회피 혹은 무력화하는 행위를 하는 경우</li>
                                        <li>"회사"가 제공하는 서비스를 정상적인 용도 이외 또는 부당한 방법으로 이용하는 경우</li>
                                        <li>"회사"의 영업을 방해할 목적으로 서비스를 비정상적으로 악용하는 경우</li>
                                    </ol>
                                </li>
                            </ol>
                        </article>

                        <article className="space-y-4">
                            <h3 className="text-xl font-semibold text-gray-700">제8조 서비스의 제공 및 이용</h3>
                            <ol className="list-decimal list-inside space-y-2 pl-6 text-gray-700">
                                <li>
                                    "회사"는 제2조 3항의 서비스를 제공할 수 있으며 그 내용은 다음 각호와 같습니다.
                                    <ul className="list-disc list-inside space-y-2 pl-6 text-gray-700">
                                        <li>“회원”이 지정한 웹사이트 주소 및 업로드한 데이터의 정보 수집 서비스</li>
                                        <li>수집된 정보를 기반하여 생성형 AI 답변 서비스</li>
                                        <li>웹사이트 및 연동채널의 방문자와 질의 답변을 통한 소통 서비스</li>
                                        <li>질의 답변 내용을 저장하여 가입자에게 제공하는 서비스</li>
                                    </ul>
                                </li>
                                <li>
                                    "회사"는 필요한 경우 서비스 내용을 추가 또는 변경할 수 있습니다. 단, 이 경우 "회사"는 추가 또는 변경 내용을 "회원"에게 공지 합니다.
                                </li>
                                <li>
                                    "회사"는 특별한 사유가 없는 한 연중무휴, 1일 24시간 서비스를 제공 합니다. 다만, "회사"는 서비스의 종류나 성질에 따라 제공하는 서비스 중
                                    일부에 대해서는 별도로 이용시간을 정할 수 있으며, 이 경우 "회사"는 그 이용시간을 사전에 "회원"에게 공지 합니다.
                                </li>
                                <li>
                                    전항에도 불구하고 회사는 다음 각호의 어느 하나에 해당하는 때에는 일정 시간 동안 서비스의 제공을 중단할 수 있습니다.
                                    <ol className="list-disc list-inside space-y-2 pl-6 text-gray-700">
                                        <li>시스템 정기점검 또는 업그레이드를 위해 부득이한 경우</li>
                                        <li>외부 솔루션 (LLM, 대형 언어모델)을 통한 서비스 및 업무처리를 거부하는 경우</li>
                                        <li>외부 솔루션 (LLM, 대형 언어모델)의 지속적인 서비스 제공이 불가능한 경우</li>
                                        <li>정전, 제반 설비의 장애 또는 이용량의 폭주 등으로 정상적인 “서비스” 이용에 지장이 발생할 우려가 있는 경우</li>
                                        <li>기타 천재지변, 국가비상사태 등으로 불가항력적 사유가 있는 경우</li>
                                        <li>컴퓨터 등 정보통신설비의 보수 점검, 교체 및 고장, 통신의 두절 등의 사유가 발생한 경우</li>
                                    </ol>
                                </li>
                                <li>
                                    "회사"는 자료의 가공과 갱신을 위한 시스템 작업시간, 장애해결을 위한 보수작업 시간, 회선 장애 등이 발생한 경우 일시적으로 서비스를 중단할 수
                                    있으며 계획된 작업의 경우 공지사항 게시, 이메일 발송, 고객센터 문자 알림 등 적절한 수단으로 서비스 중단 시간과 작업 내용을 고지합니다. 다만,
                                    "회사"가 사전에 통지할 수 없는 부득이한 사유가 있는 경우 사후에 통지할 수 있습니다.
                                </li>
                            </ol>
                        </article>

                        <article className="space-y-4">
                            <h3 className="text-xl font-semibold text-gray-700">제9조 서비스 요금</h3>
                            <ol className="list-decimal list-inside space-y-2 pl-6 text-gray-700">
                                <li>
                                    유료 서비스 이용 "회원"은 회사의 서비스 사이트에 안내 된 이용료 플랜에 따른 비용을 지불해야 합니다.
                                </li>
                                <li>
                                    "회사"는 유료서비스 이용금액을 서비스의 종류 및 기간에 따라 "회사"가 변경할 수 있습니다. 다만, 변경 이전에 적용 또는 계약한 금액은 소급하여
                                    적용하지 않습니다. 변경 사항을 수락하지 않을 경우, 회사는 서비스 제공을 중단할 권리를 보유합니다.
                                </li>
                            </ol>
                        </article>

                        <article className="space-y-4">
                            <h3 className="text-xl font-semibold text-gray-700">제10조 이용료 지불 및 결제방법</h3>
                            <ol className="list-decimal list-inside space-y-2 pl-6 text-gray-700">
                                <li>
                                    유료 서비스 이용료는 신용카드 결제를 원칙으로 합니다. 이를 위하여 회원은 “회사”와 결제 제공 업체와 계약이 지정된 신용카드를 등록해야 합니다.
                                </li>
                                <li>
                                    이용료의 지불은 이용료 플랜에 안내한 방식으로 구분하여 진행됩니다
                                </li>
                                <li>
                                    회원이 제1항에 따라 카드를 등록하면, 전항의 결제 방식을 동의한 것으로 간주합니다. 이때 회사는 전항 제2항의 결제를 위한 별도 페이지를 제공하고
                                    이를 알립니다.
                                </li>
                            </ol>
                        </article>

                        <article className="space-y-4">
                            <h3 className="text-xl font-semibold text-gray-700">제11조 환불</h3>
                            <ol className="list-decimal list-inside space-y-2 pl-6 text-gray-700">
                                회원은 회사에 환불을 요구할 수 있습니다. 아래 각호에 따라 환불 절차가 진행 됩니다.
                                <li>
                                    회원은 회사에 서비스 환불을 요구할 수 있습니다. 결제 유형별 환불정책은 다음과 같습니다.
                                    <ul className="list-disc list-inside space-y-2 pl-6 text-gray-700">
                                        <li>정기구독 결제: 회원이 해지를 요청하면 월 사용 기간을 일할 계산하여 차액을 환불 합니다. (단 가입 후 7일 이내 미사용 시 전액
                                            환불)
                                        </li>
                                        <li>일시 결제: 일시 결제 후 서비스 이용 전 상황인 경우 전액 환불하고 서비스 이용 후 사용한 자원을 차감 후 환불 합니다.</li>
                                    </ul>
                                </li>
                                <li>
                                    회원은 결제정보 안내 페이지에서 서비스 이용 기간을 확인 할 수 있습니다.
                                </li>
                            </ol>
                        </article>
                    </section>

                    {/* 제3장 계약의 존속 */}
                    <section className="space-y-6">
                        <h2 className="flex text-2xl font-bold text-gray-800 justify-center">제3장 계약의 존속</h2>

                        <article className="space-y-4">
                            <h3 className="text-xl font-semibold text-gray-700">제12조 계약기간</h3>
                            <ol className="list-decimal list-inside space-y-2 pl-6 text-gray-700">
                                <li>
                                    “서비스” 이용계약은 “회원”이 되고자 하는 자가 “회사”가 제공하는 이용신청 방법에 따라 “서비스” 이용 신청을 하고 “회사”가 이러한 신청에 대하여
                                    승낙함으로써 체결됩니다.
                                </li>
                                <li>
                                    당사자 일방이 전조 1항 또는 제15조를 원인으로 계약을 계속하기 어려운 경우를 제외하고 계약은 계속 됩니다.
                                </li>
                            </ol>
                        </article>

                        <article className="space-y-4">
                            <h3 className="text-xl font-semibold text-gray-700">제13조 계약의 변경</h3>
                            <ol className="list-decimal list-inside space-y-2 pl-6 text-gray-700">
                                <li>
                                    회사는 이 약관의 내용을 변경하고자 하는 경우 그 적용 예정일로부터 14일 전에 서비스의 공지사항을 통해 알립니다. 다만 약관의 개정이 회원에게 불리한
                                    내용을 담고 있는 경우에는 제16조의 방법으로 알려야 합니다.
                                </li>
                                <li>
                                    회사는 전항의 공지에서 14일 이상의 기간을 정하고, 회원이 그 기간 내에 거부의 의사표시를 하지 않는 경우에는 개정된 약관에 동의한 것으로 봅니다.
                                </li>
                                <li>
                                    전항의 기간 내에 회원이 거부의 의사를 표시한 때에는 개정된 약관의 시행일에 계약이 해지된 것으로 봅니다. 이때 회원은 그 의사표시와 동시에 계약을
                                    해지 할 수도 있습니다.
                                </li>
                            </ol>
                        </article>

                        <article className="space-y-4">
                            <h3 className="text-xl font-semibold text-gray-700">제14조 계약 종료시의 의무</h3>
                            <p className="text-gray-600">
                                “회사”가 회원을 위해 보관한 자료는 계약 종료 후 5 영업일 내에 삭제합니다.
                            </p>
                        </article>
                    </section>

                    {/* 제4장 해지 및 손해배상 */}
                    <section className="space-y-6">
                        <h2 className="flex text-2xl font-bold text-gray-800 justify-center">제4장 해지 및 손해배상</h2>

                        <article className="space-y-4">
                            <h3 className="text-xl font-semibold text-gray-700">제15조 계약의 해지, 손해배상</h3>
                            <ol className="list-decimal list-inside space-y-2 pl-6 text-gray-700">
                                <li>
                                    “유료 서비스”는 “회원”이 관리메뉴, 고객센터 등을 통해 “정기구독”을 해지할 수 있습니다.
                                </li>
                                <li>
                                    “회원”이 “정기구독”을 해제∙해지했을 경우 제11조에 따라 환불하고, 유료 서비스 이용 계약을 중단합니다. “회사”는 관계 법령 등에서 정하는 절차에
                                    따라 이를 신속하게 처리합니다.
                                </li>
                                <li>
                                    “유료 서비스”를 유지하고자 하는 “회원”은 이용요금의 체납 또는 결제수단의 연체가 발생하지 않도록 사전에 조치하여야 합니다. “회원”이 “유료
                                    서비스” 이용요금을 미납하는 경우, “회사”는 “회원”에 대하여 “서비스” 이용제한 조치를 취할 수 있습니다
                                </li>
                                <li>
                                    “회원”이 전항을 위반하여 “유료 서비스”의 신청 또는 동의에 따라 정기결제 중인 “유료 서비스”를 이용하는 중에 서비스 이용요금을 체납하는 경우
                                    연체가 발생한 날 자동으로 이용 해지가 될 수 있습니다.
                                </li>
                            </ol>
                        </article>
                    </section>

                    {/* 제5장 기타 */}
                    <section className="space-y-6">
                        <h2 className="flex text-2xl font-bold text-gray-800 justify-center">제5장 기타</h2>

                        <article className="space-y-4">
                            <h3 className="text-xl font-semibold text-gray-700">제16조 통지의 방법</h3>
                            <ol className="list-decimal list-inside space-y-2 pl-6 text-gray-700">
                                <li>
                                    이 약관에 따라 회원에게 일정한 사항을 알릴 때에는 원칙적으로 “회원”이 등록한 전자우편 및 서비스 사이트를 사용합니다.
                                </li>
                                <li>
                                    전항에도 불구하고 “회원 전체”를 대상으로 하거나 긴급한 사유가 발생한 경우에는 서비스 페이지의 알림창을 통해 알릴 수 있습니다.
                                </li>
                                <li>
                                    “회사”는 “회원”의 고의 또는 과실로 본 조의 통지를 인지하지 못한 경우에 발생하는 손해에 대하여 책임을 지지 않습니다.
                                </li>
                            </ol>
                        </article>

                        <article className="space-y-4">
                            <h3 className="text-xl font-semibold text-gray-700">제17조 비밀유지의무</h3>
                            <ol className="list-decimal list-inside space-y-2 pl-6 text-gray-700">
                                <li>
                                    각 당사자는 이 약관의 체결 및 이행과정에서 취득한 상대방의 영업비밀에 대하여, 계약기간 중은 물론이고 계약의 종료 후에도 제3자에게 유출하거나 다른
                                    목적에 이용하여서는 안 됩니다.
                                </li>
                                <li>
                                    전항을 위반하여 상대방에게 손해가 발생한 경우, 손해를 입은 당사자는 그 상대방에게 손해배상을 청구할 수 있습니다.
                                </li>
                            </ol>
                        </article>

                        <article className="space-y-4">
                            <h3 className="text-xl font-semibold text-gray-700">제18조 통지의무</h3>
                            <p className="text-gray-600">
                                각 당사자는 이 약관에 규정된 사항 이외에도 계약의 이행에 중대한 영향을 미칠 수 있는 사유가 예견되는 경우 지체 없이 상대방에게 통지하여야 합니다.
                            </p>
                        </article>

                        <article className="space-y-4">
                            <h3 className="text-xl font-semibold text-gray-700">제19조 권리∙의무의 양도 금지</h3>
                            <p className="text-gray-600">
                                각 당사자는 상대방의 서면 동의 없이 이 약관상의 권리 또는 의무를 제3자에게 양도하거나 이전할 수 없습니다.
                            </p>
                        </article>

                        <article className="space-y-4">
                            <h3 className="text-xl font-semibold text-gray-700">제20조 분쟁해결</h3>
                            <ol className="list-decimal list-inside space-y-2 pl-6 text-gray-700">
                                <li>
                                    이 약관과 관련하여 분쟁이 발생하는 경우 각 당사자는 원만한 해결을 위하여 서로 협력합니다.
                                </li>
                                <li>
                                    당사자 간에 제기된 소송은 대한민국법을 준거법으로 하며, 서울중앙지방법원이 배타적인 제1심 관할권을 갖습니다.
                                </li>
                            </ol>
                        </article>
                    </section>

                    {/* 부칙 */}
                    <section className="space-y-6">
                        <h2 className="text-2xl font-bold text-gray-800">부칙</h2>
                        <p className="text-gray-600">
                            이 약관은 2025년 1월 1일부터 적용 됩니다.
                        </p>
                    </section>
                </div>
            </div>
        </div>
    );
};

export default TermsOfServiceView;
